import React from "react";
import { SDLCMetadataTypeGuards } from "@sscs/types";
import { DataTable, LongTextLabel, Table } from "@sscs/ui";
import { CRYPTO_ASSET_KIND, CRYPTO_ASSET_KIND_LABEL, } from "../../../../constants";
import { itemIdFiltered } from "../../../../store/cbomSlice";
import { useReportDispatch } from "../../../hooks";
import { transformMaterialType } from "../../../utils";
import CryptoCertificateCard from "../../CryptoCards/CryptoCertificateCard";
import CryptoMaterialCard from "../../CryptoCards/CryptoMaterialCard";
import LinkToReportTab from "../../linkToReportTab/LinkToReportTab";
import styles from "./cryptographyReferences.module.scss";
const AssetCard = ({ CBOMRoute, cryptoAsset, }) => {
    const dispatch = useReportDispatch();
    const details = cryptoAsset.details;
    if (!details)
        return React.createElement(React.Fragment, null);
    const link = (React.createElement(LinkToReportTab, { id: `view-in-cbom`, to: CBOMRoute, onClick: () => {
            dispatch(itemIdFiltered({
                item_id: cryptoAsset.id,
                kind: cryptoAsset.kind,
                type: cryptoAsset.type,
            }));
        }, color: "link" }, "View in CBOM"));
    if (details.kind === CRYPTO_ASSET_KIND.certificate) {
        return React.createElement(CryptoCertificateCard, { certificate: details, link: link });
    }
    else if (details.kind === CRYPTO_ASSET_KIND.material) {
        return React.createElement(CryptoMaterialCard, { material: details, link: link });
    }
    return React.createElement(React.Fragment, null);
};
const COLUMNS = [
    { id: "kind", label: "Kind", width: "150px" },
    { id: "type", label: "Type", width: "100%" },
];
const CryptographyReferences = ({ CBOMRoute, references, }) => {
    const dispatch = useReportDispatch();
    if (references.length === 1) {
        return React.createElement(AssetCard, { CBOMRoute: CBOMRoute, cryptoAsset: references[0] });
    }
    // Metadata supports multiple crypto asset references but engine is generating a single one
    // This table is here just in case engine changes so UI doesn't break if there is more than one reference
    return (React.createElement(DataTable, { columns: COLUMNS, title: "Cryptographic assets" }, references.map((reference, index) => (React.createElement(Table.Row, { key: `${reference.kind}-${index}` },
        React.createElement(Table.Cell, null, CRYPTO_ASSET_KIND_LABEL[reference.kind]),
        React.createElement(Table.Cell, { className: styles["link-container"] },
            React.createElement(LinkToReportTab, { id: `secret-cbom-link-${index}`, key: reference.id, to: CBOMRoute, onClick: () => {
                    dispatch(itemIdFiltered({
                        item_id: reference.id,
                        kind: reference.kind,
                        type: reference.type,
                    }));
                }, color: "link" },
                React.createElement(LongTextLabel, { label: SDLCMetadataTypeGuards.stringIsCryptoMaterial(reference.type)
                        ? transformMaterialType(reference.type)
                        : reference.type }))))))));
};
export default CryptographyReferences;
//# sourceMappingURL=CryptographyReferences.js.map